import { DoneAllOutlined, RemoveDoneOutlined } from "@mui/icons-material";
import {
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import ConfigVisibilidadeTile from "../configVisibilidadeTile";
import useStyles from "./styles";

// Bloco de configuração: agrupa um conjunto de opções (CDNs ou tipos de
// tráfego) com contagem de itens visíveis e ações rápidas de seleção
export default function ConfigVisibilidadeBlock({
  title,
  description,
  options,
  selection,
  onToggleItem,
  onToggleAll,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const total = options.length;
  const selecionados = options.filter((opt) => selection?.[opt.key]).length;

  return (
    <Paper variant="outlined" sx={styles.block}>
      <Box sx={styles.header}>
        <Box>
          <Typography sx={styles.title}>{title}</Typography>
          <Typography sx={styles.description}>{description}</Typography>
        </Box>
        <Box sx={styles.actions}>
          <Chip
            size="small"
            label={`${selecionados}/${total} visíveis`}
            sx={styles.count}
          />
          <Tooltip title="Selecionar todos">
            <IconButton size="small" onClick={() => onToggleAll(options, true)}>
              <DoneAllOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Ocultar todos">
            <IconButton
              size="small"
              onClick={() => onToggleAll(options, false)}
            >
              <RemoveDoneOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={styles.grid}>
        {options.map((item) => (
          <ConfigVisibilidadeTile
            key={item.key}
            item={item}
            checked={!!selection?.[item.key]}
            onToggle={onToggleItem}
          />
        ))}
      </Box>
    </Paper>
  );
}
